// This component displays all of the menu items for a given ScheduledMenu.

import { Text } from "@fluentui/react";
import React from "react";
import { useSelector } from "react-redux";
import { setSelectedItem } from "../../reducers/diningReducer";
import { cafeSelector, selectedItemSelector, stationSelector } from "../../selectors/diningSelector";
import styles from "../../styles/menuPreview.module.css";
import MenuItemCard from "./MenuItemCardView";
import { PreviewMenu, PreviewMenuItem } from "./types/menuPreviewTypes";

export interface StationCardProps {
  previewMenu: PreviewMenu;
}

// Takes a scheduledMenu and returns a formatted section displaying the station name followed by a list of MenuItemCards.
const StationCard = ({ previewMenu }: StationCardProps) => {
  const selectedItem = useSelector(selectedItemSelector);
  const selectedStation = useSelector(stationSelector);
  const selectedCafe = useSelector(cafeSelector);
  return (
    <li key={previewMenu.stationId}>
      <Text className={styles.stationTitle} key={previewMenu.stationName}>
        {previewMenu.stationName}
      </Text>
      {previewMenu.items?.map((item: PreviewMenuItem) => (
        <MenuItemCard
          onSelect={() => {
            item.itemData && setSelectedItem(item?.itemData);
          }}
          key={item.menuItemId}
          menuItem={item}
          selected={selectedItem?.id === item.menuItemId}
          cafeId={selectedCafe?.id || ""}
          stationId={selectedStation?.id || ""}
        />
      ))}
    </li>
  );
};

export default StationCard;
